export const CREATE_MULTIPLE_DOWNLOAD_REQUEST =
  "CREATE_MULTIPLE_DOWNLOAD_REQUEST";
export const CREATE_MULTIPLE_DOWNLOAD_SUCCESS =
  "CREATE_MULTIPLE_DOWNLOAD_SUCCESS";
export const CREATE_MULTIPLE_DOWNLOAD_FAILURE =
  "CREATE_MULTIPLE_DOWNLOAD_FAILURE";

export const GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST =
  "GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST";
export const GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS =
  "GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS";
export const GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE =
  "GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE";

export const GET_SINGLE_DOWNLOAD_REQUEST = "GET_SINGLE_DOWNLOAD_REQUEST";
export const GET_SINGLE_DOWNLOAD_SUCCESS = "GET_SINGLE_DOWNLOAD_SUCCESS";
export const GET_SINGLE_DOWNLOAD_FAILURE = "GET_SINGLE_DOWNLOAD_FAILURE";
